import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre1/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre2/", true, /\.webp/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre3/", true, /\.webp/)); }
const ZonaInfantil = () => { return ImportHelper.importAll(require.context("../assets/images/SpinZonaInfantil/", true, /\.webp/)); }
const ZonaMascotas = () => { return ImportHelper.importAll(require.context("../assets/images/SpinZonaMascotas/", true, /\.webp/)); }
const PlacaDeportiva = () => { return ImportHelper.importAll(require.context("../assets/images/SpinPlacaDeportiva/", true, /\.webp/)); }
const SalonSocial = () => { return ImportHelper.importAll(require.context("../assets/images/Salonsocial/", true, /\.webp/)); }
const Piscina = () => { return ImportHelper.importAll(require.context("../assets/images/Piscina/", true, /\.webp/)); }
const GymAireLibre = () => { return ImportHelper.importAll(require.context("../assets/images/Gymairelibre/", true, /\.webp/)); }
const Gym = () => { return ImportHelper.importAll(require.context("../assets/images/Gym/", true, /\.webp/)); }
const BBQ = () => { return ImportHelper.importAll(require.context("../assets/images/BBQ/", true, /\.webp/)); }


export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": Torre1,
    "Torre 2": Torre2,
    "Torre 3": Torre3,
    "Parque infantil": ZonaInfantil,
    "Zona de mascotas": ZonaMascotas,
    "Placa polideportiva": PlacaDeportiva,
    "Salón social": SalonSocial,
    "Piscina": Piscina,
    "Gimnasio al aire libre": GymAireLibre,
    "Gym": Gym,
    "BBQ": BBQ,
}
